<template>
    <v-card width="100%" outlined class="pa-4">
      <apexchart
        height="400px"
        type="donut"
        :options="chartOptions"
        :series="chartSeries"
      ></apexchart>
    </v-card>
  </template>
  
  <script>
  export default {
    props: {
      title_header: {
        type: String,
        default: "Título del Gráfico",
      },
      data: {
        type: Object,
        default: () => ({
          label: [],
          series: [],
        }),
        required: true,
      },
    },
    data() {
      return {
        colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#546E7A', '#26a69a', '#D10CE8'],
      };
    },
    computed: {
      chartSeries() {
        return this.data.series;
      },
      chartOptions() {
        return {
          chart: {
            type: 'donut',
            animations: {
              enabled: true,
              easing: 'easeinout',
              speed: 800,
              animateGradually: {
                enabled: true,
                delay: 150
              },
              dynamicAnimation: {
                enabled: true,
                speed: 350
              }
            },
          },
          title: {
            text: this.title_header,
            align: 'center',
            style: {
              fontSize: '22px',
              fontWeight: 'bold',
              fontFamily: 'Roboto, sans-serif',
              color: '#333',
            },
          },
          labels: this.data.label,
          colors: this.colors,
          plotOptions: {
            pie: {
              donut: {
                size: '65%',
                background: 'transparent',
                labels: {
                  show: true,
                  name: {
                    show: true,
                    fontSize: '22px',
                    fontFamily: 'Roboto, sans-serif',
                    fontWeight: 600,
                    color: undefined,
                    offsetY: -10,
                  },
                  value: {
                    show: true,
                    fontSize: '16px',
                    fontFamily: 'Roboto, sans-serif',
                    fontWeight: 400,
                    color: undefined,
                    offsetY: 16,
                    formatter: function (val) {
                      return parseFloat(val).toFixed(1) + '%';
                    }
                  },
                  total: {
                    show: true,
                    showAlways: false,
                    label: 'Total',
                    fontSize: '22px',
                    fontFamily: 'Roboto, sans-serif',
                    fontWeight: 600,
                    color: '#373d3f',
                    formatter: function (w) {
                      return w.globals.seriesTotals.reduce((a, b) => a + b, 0).toFixed(1) + '%';
                    }
                  }
                }
              }
            }
          },
          dataLabels: {
            enabled: false
          },
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }],
          legend: {
            position: 'right',
            offsetY: 0,
            height: 230,
            fontSize: '14px',
            fontFamily: 'Roboto, sans-serif',
          },
          tooltip: {
            y: {
              formatter: function(value) {
                return value.toFixed(1) + '%';
              }
            }
          }
        };
      }
    },
    watch: {
      data: {
        handler: function (newValue) {
          this.$nextTick(() => {
            if (this.$refs.chart) {
              this.$refs.chart.updateOptions({
                labels: newValue.label,
              });
              this.$refs.chart.updateSeries(newValue.series);
            }
          });
        },
        deep: true,
        immediate: true
      }
    },
  };
  </script>
  
  <style scoped>
  .v-card {
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
  }
  
  :deep(.apexcharts-legend-text) {
    font-family: 'Roboto', sans-serif !important;
  }
  
  :deep(.apexcharts-title-text) {
    font-family: 'Roboto', sans-serif !important;
  }
  </style>